import { Box } from '@mui/material';
import { createPortal } from 'react-dom';
import { useWatch } from 'react-hook-form';

import { RemarkButton } from '@Components/IconButton';
import { useDisclosure } from '@hooks/useDisclosure';
import Remark from '@Components/Remark';
import { useGreenhouseForm } from '../EsgGreenhouseFormProvider';
import { IGreenhouseStandardFormValues } from '../EsgGreenhouseFormProvider/types';

export const GH_STANDARD_REMARK_ID = 'gh-standard-remark';

const GreenhouseStandardRemark = () => {
  const { control, getValues } = useGreenhouseForm();
  const { remark } =
    getValues(`greenhouseStandard`) ?? ({} as IGreenhouseStandardFormValues);

  const [isRemarkOpen, { open, close }] = useDisclosure(!!remark);

  const ghStandardRemarkEl = document.getElementById(GH_STANDARD_REMARK_ID);

  const { completedSection } =
    useWatch({
      name: 'greenhouseStandard',
      control,
    }) ?? ({} as IGreenhouseStandardFormValues);

  const { isCompletedTh = false, isCompletedEn = false } =
    completedSection ?? {};

  return (
    <>
      <RemarkButton onClick={open} disabled={isCompletedTh && isCompletedEn} />
      {isRemarkOpen &&
        ghStandardRemarkEl &&
        createPortal(
          <Box mt={2}>
            <Remark
              onDelete={close}
              topic="การปฎิบัติตามหลักการและมาตรฐานด้านการจัดการก๊าซเรือนกระจกหรือการเปลี่ยนแปลงสภาพภูมิอากาศ"
              setOpen={open}
              fieldPath="greenhouseStandard.remark"
              isCompletedEn={isCompletedEn}
              isCompletedTh={isCompletedTh}
            />
          </Box>,
          ghStandardRemarkEl
        )}
    </>
  );
};

export default GreenhouseStandardRemark;
